import { DollarSign } from 'lucide-react';

export function TipBadge({ tipsCount, tipsTotal }) {
  if (!tipsCount || tipsCount === 0) return null;

  return (
    <span
      className="inline-flex items-center gap-1 text-xs text-emerald-400"
      data-testid="tip-badge"
    >
      <DollarSign className="w-3 h-3" />
      {tipsTotal ? `$${tipsTotal.toFixed(0)}` : tipsCount} {tipsCount === 1 ? 'tip' : 'tips'}
    </span>
  );
}
